module.exports = __webpack_public_path__ + "static/img/vip-header-2.935aabc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/priceCard/vip-header-2.png
// module id = k9V0
// module chunks = 1